import { render, staticRenderFns } from "./RecordedDetail.vue?vue&type=template&id=35ec27c7&scoped=true"
import script from "./RecordedDetail.vue?vue&type=script&lang=ts"
export * from "./RecordedDetail.vue?vue&type=script&lang=ts"
import style0 from "./RecordedDetail.vue?vue&type=style&index=0&id=35ec27c7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec27c7",
  null
  
)

export default component.exports